import * as tslib_1 from "tslib";
/* I97 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Send = /** @class */ (function (_super) {
    tslib_1.__extends(Send, _super);
    function Send() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Send.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
                    React.createElement("path", { d: "M15.181 9.982a.369.369 0 0 0-.529-.509L8.04 15.1l-3.493-1.35a.85.85 0 0 1-.1-1.542l14.5-8.122a.715.715 0 0 1 1.05.697l-1.27 13.257a.878.878 0 0 1-1.202.733l-4.25-1.646-2.669 2.5a.69.69 0 0 1-1.16-.508v-1.964l5.736-7.173z" })))));
    };
    return Send;
}(React.Component));
export default Send;
//# sourceMappingURL=Send.js.map